import React, { useState, useEffect, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useQueries from '../../../database/useQueries';
import FormTemplate from '../../template/form/FormTemplate';
import { useSelector } from 'react-redux';
import LoadingOverlay from '../pagesMains/LoadingOverlay';
import CommponentOptions from '../plagins/data/commponentOptions';
import { GlobalContext } from '../../../App';
import { DataContext, TemplateContext } from '../pagesMains/GravesManagers/Graves';
import { createFetchDataServer } from '../../../database/fetchData';
import { fullSelectedBlocks, fullSelectedCemeteries, fullSelectedPlots } from '../plagins/data/multiSelectedForm';

const NAME_ENTITY = 'חלקה';

function PlotUpdate() {
  // קבלת ערכים מהסטור
  const columns = useSelector((state) => state.columnsFormPlots.data);

  const { setTitle } = useContext(GlobalContext);
  const { setTotalWidthContainer } = useContext(TemplateContext);

  // טעינת היוזים לפונקציות עזר
  const { addOrUpdateDataPlot, getEntitiesByAttr, getEntityByAttr } = useQueries();

  const context = useContext(DataContext);
  const fetchDataServer = createFetchDataServer(context);

  // ערכי הראוטר
  const location = useLocation();
  const navigate = useNavigate();
  const { value } = location.state || {};
  const [myPlot, setMyPlot] = useState(context?.contextPlots?.find((item) => item?.unicId === value?.unicId) || value);
  useEffect(() => {
    setMyPlot(context?.contextPlots?.find((item) => item?.unicId === value?.unicId) || value);
  }, [context?.contextPlots]);

  useEffect(() => {
    setTotalWidthContainer(1200);
    setTitle(`עדכון חלקה`);
  }, [location.pathname]);

  // איזור המשתנים והסטייטים
  // משתנים לטופס
  const [fieldsWithDynamicDisabled, setFieldsWithDynamicDisabled] = useState([]); // השדות
  const [formValues, setFormValues] = useState({}); // ערכי השדות
  const [errors, setErrors] = useState({}); // שגיאת השדות
  // עוקב אחר שליחת נתונים לשרת דרך פונקציית סבמיט
  const [loadingData, setloadingData] = useState(false);

  // משתנים לערכי סלקט של השדות
  const [cemeteries, setCemeteries] = useState([]);
  const [blocks, setBlocks] = useState([]);
  const [plots, setPlots] = useState([]);

  // פונקציה לטעינת השדות מתוך הסטור
  const myColumns = () => {
    return columns.map((field) => {
      return {
        ...field,
        disabled: field.disabled && myPlot !== undefined,
        required: field.required || false,
        show: field?.show || false
      };
    });
  };

  // טעינת הנתונים לאחר קבלת הערכים מהדאטה בייס הלוקלי
  const handleAllDataLoaded = () => {
    setFieldsWithDynamicDisabled(myColumns());
    if (myPlot?.unicId) {
      let initialFormValues = myColumns()
        .filter((field) => field?.name)
        .reduce(
          (acc, field) => {
            let fieldValue = myPlot[field.name] || '';
            return {
              ...acc,
              [field.name]: fieldValue
            };
          },
          {
            id: myPlot?.id,
            unicId: myPlot?.unicId
          }
        );
        const block = getEntityByAttr(context?.contextBlocks, 'unicId', myPlot?.blockId);
        initialFormValues = { ...initialFormValues, cemeteryId: block?.cemeteryId , blockId: block?.unicId };

      fieldAuto(myPlot);

      setFormValues(initialFormValues);
    }
  };

  // טעינת ערכים אוטומטית לשדות
  const fieldAuto = (data) => {
    const block = getEntityByAttr(context?.contextBlocks, 'unicId', data?.blockId);

    let blocks = getEntitiesByAttr(context?.contextBlocks, 'cemeteryId', block?.cemeteryId);
    let plots = getEntitiesByAttr(context?.contextPlots, 'blockId', block?.blockId);

    setCemeteries(fullSelectedCemeteries(context?.contextCemeteries));
    setBlocks(fullSelectedBlocks(blocks));
    setPlots(plots);
  };

  // פעולות המתבצעות רק לאחר קבלת דאטה בייס ווליו מהראוטר
  useEffect(() => handleAllDataLoaded(), []);

  const fieldChangeCemeteryId = (event, newFormValues) => {
    delete newFormValues?.blockId;

    if (event.target.value === '') {
      setBlocks(fullSelectedBlocks(context?.contextBlocks));
    } else {
      const blocks = getEntitiesByAttr(context?.contextBlocks, 'cemeteryId', event.target.value);
      const plots = context?.contextPlots.filter((plot) => blocks.some((block) => block?.unicId === plot.blockId));
      setBlocks(fullSelectedBlocks(blocks));
      setPlots(plots);
    }
  };
  const fieldChangeBlockId = (event, newFormValues) => {
    const plots = getEntitiesByAttr(context?.contextPlots, 'blockId', event.target.value);
    const block = getEntityByAttr(context?.contextBlocks, 'unicId', event.target.value);
    const cemetery = getEntityByAttr(context?.contextCemeteries, 'unicId', block?.cemeteryId);

    setPlots(plots);
    return { cemeteryId: cemetery?.unicId };
  };
  const handleChange = (event) => {
    let newFormValues = formValues;

    if (event.target.name === 'cemeteryId') {
      fieldChangeCemeteryId(event, newFormValues);
    }
    if (event?.target?.name === 'blockId') {
      const res = fieldChangeBlockId(event, newFormValues);
      if (event.target.value !== '') {
        newFormValues = { ...newFormValues, cemeteryId: res?.cemeteryId };
      }
    }
    setFormValues({ ...newFormValues, [event.target.name]: event.target.value });
  };
  const validateForm = () => {
    let tempErrors = {};
    let formIsValid = true;

    columns.forEach((field) => {
      if (field.required && !formValues[field.name]) {
        tempErrors[field.name] = 'שדה חובה';
        formIsValid = false;
      }
      if (field.notRepeat && formValues[field.name]) {
        if (plots.some((item) => item[field.name] === formValues[field.name])) {
          tempErrors[field.name] = `הערך ${formValues[field.name]} כבר קיים`;
          formIsValid = false;
        }
      }
    });

    setErrors(tempErrors);
    return formIsValid;
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    const newFormValues = { ...formValues };
    delete newFormValues.cemeteryId;
    if (validateForm()) {
      setloadingData(true);

      let res = await addOrUpdateDataPlot(newFormValues);
      if (res === 200) {
        let updatePlot = context?.contextPlots?.find((plot) => plot?.id === formValues?.id);
        updatePlot = { ...updatePlot, ...formValues };
        let update =  { plotNameHe: updatePlot.plotNameHe, plotNameEn: updatePlot.plotNameEn }

        context?.setContextPlots((prev) => prev.map((item) => (item.unicId === updatePlot.unicId ? updatePlot : item)));
        context?.setContextAreaGraves((prev) => prev.map((item) => (item?.plotId === updatePlot?.unicId ? { ...item, ...update } : item)));
        setloadingData(false);
        navigate(-1);
      }
    }
  };

  if (loadingData) return <LoadingOverlay />;

  return (
    <FormTemplate
      title={`עריכת ${NAME_ENTITY}`}
      btn={`עדכן`}
      fields={fieldsWithDynamicDisabled}
      columns={columns}
      formValues={formValues}
      handleChange={handleChange}
      handleSubmit={handleSubmit}
      errors={errors}
      options={{
        cemeteryId: cemeteries,
        blockId: blocks
      }}
    />
  );
}

export default PlotUpdate;
